import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BlobStorageService {
  private http = inject(HttpClient);

  private httpOptions: any = {
    observe: 'response',
    // 'application/json' ist kein gueltiger XHR-responseType (Browser-Warnung
    // bei jedem Request); der Code parst selbst via JSON.parse -> 'text'.
    responseType: 'text',
    headers: new HttpHeaders({
      Accept: 'application/json',
    }),
  };

  public async getJsonFromUrl(url: string): Promise<any> {
    const menuJson: any = await lastValueFrom(this.http.get(url, this.httpOptions));
    return JSON.parse(menuJson.body);
  }
}
